import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Apple, Play, Leaf, Mail, Facebook } from "lucide-react";
import { GRASS_BG, LOGO_URL, CONTACT_EMAIL } from "@/lib/landing";

export default function Footer() {
  return (
    <footer className="relative z-10">
      {/* Final CTA */}
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url(${GRASS_BG})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ld-bg)] via-[var(--ld-bg)]/80 to-[var(--ld-bg)]" />
        <div className="relative mx-auto max-w-4xl px-5 py-28 text-center sm:px-8">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="ld-display text-[clamp(2.25rem,6vw,4.5rem)]"
          >
            Your Lawn, Your Rules<br />
            <span className="text-[var(--ld-lime)]">Let's Dominate together</span>
          </motion.h2>
          <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
            <a href="https://apps.apple.com/app/id6786804897" target="_blank" rel="noopener noreferrer" data-testid="footer-appstore" className="ld-btn-lime inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-black">
              <Apple className="h-5 w-5" /> Download on the App Store
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.growcalc.app" target="_blank" rel="noopener noreferrer" data-testid="footer-playstore" className="ld-btn-ghost inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-black">
              <Play className="h-4 w-4" /> Get it on Google Play
            </a>
          </div>
        </div>
      </section>

      {/* Footer bar */}
      <div className="border-t border-[var(--ld-line)] bg-[var(--ld-bg)]">
        <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="GrowCalc" className="h-10 w-10 rounded-xl object-contain" />
            <div>
              <div className="text-lg font-black">GrowCalc</div>
              <div className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-[0.2em] text-[var(--ld-lime)]">
                <Leaf className="h-3 w-3" /> All-in-One Lawncare Tool
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm font-bold">
            <a href="#features" className="text-[var(--ld-muted)] transition-colors hover:text-[var(--ld-text)]">Features</a>
            <a href="#faq" className="text-[var(--ld-muted)] transition-colors hover:text-[var(--ld-text)]">FAQ</a>
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-[var(--ld-muted)] transition-colors hover:text-[var(--ld-text)]">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-[var(--ld-muted)] transition-colors hover:text-[var(--ld-text)]">Terms of Service</Link>
            <Link to="/delete-account" data-testid="footer-delete-account-link" className="text-[var(--ld-muted)] transition-colors hover:text-[var(--ld-text)]">Delete account</Link>
            <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="inline-flex items-center gap-1.5 text-[var(--ld-muted)] transition-colors hover:text-[var(--ld-text)]">
              <Mail className="h-4 w-4" /> {CONTACT_EMAIL}
            </a>
            <a href="https://www.facebook.com/share/17r3Wee2KM/" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="inline-flex items-center gap-1.5 text-[var(--ld-muted)] transition-colors hover:text-[var(--ld-text)]">
              <Facebook className="h-4 w-4" /> Facebook
            </a>
          </div>
        </div>
        <div className="border-t border-[var(--ld-line)] py-6 text-center text-xs font-semibold text-[var(--ld-muted)]">
          © 2026 GrowCalc. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
